import {
  GOOGLE_ADS_ACCOUNT_ID,
  GOOGLE_ADS_PLTV_ACCOUNT_ID,
  GOOGLE_ADS_PLTV_ACCOUNT_SUFFIX,
  GOOGLE_ADS_PLTV_ACCOUNTS,
  GOOGLE_ADS_REVIEW_ACCOUNT_ID,
  GOOGLE_ADS_SGTM_ACCOUNT_ID,
} from '../constants';
import { isReviewSource } from './reviewPurchaseConversion';

const getPLTVAccountId = (utmAccount: unknown): string | null => {
  const accountId = String(utmAccount ?? '').replace(/\D/g, '');

  if (!GOOGLE_ADS_PLTV_ACCOUNTS.includes(accountId)) return null;

  return `${accountId}${GOOGLE_ADS_PLTV_ACCOUNT_SUFFIX}`;
};

export const resolveGoogleAdsAccountId = ({
  flowType,
  utmAccount,
}: {
  flowType?: string;
  utmAccount?: unknown;
}): string => {
  if (flowType === 'sgtm') return GOOGLE_ADS_SGTM_ACCOUNT_ID;

  const pltvAccountId = getPLTVAccountId(utmAccount);
  if (pltvAccountId) return pltvAccountId;

  if (flowType === 'pl_value') return GOOGLE_ADS_PLTV_ACCOUNT_ID;
  if (isReviewSource()) return GOOGLE_ADS_REVIEW_ACCOUNT_ID;

  return GOOGLE_ADS_ACCOUNT_ID;
};
